import {
  ref,
  deleteObject,
  uploadBytes,
  getDownloadURL,
} from "firebase/storage";
import { storage } from "../connection";
import logger from "../../../utils/logger";

export async function deleteImage(imagePath) {
  if (!imagePath) {
    throw new Error("imagePath is required for image deletion");
  }

  try {
    const imageRef = ref(storage, imagePath);
    await deleteObject(imageRef);
    logger.info(`Image deleted successfully: ${imagePath}`);
  } catch (error) {
    logger.error(`Failed to delete image at ${imagePath}:`, error);
    throw new Error(`Failed to delete image: ${error.message}`);
  }
}

export async function uploadImage(imageFile, imagePath) {
  if (!imageFile || !imagePath) {
    throw new Error("imageFile and imagePath are required for upload");
  }

  try {
    const imageRef = ref(storage, imagePath);
    await uploadBytes(imageRef, imageFile);
    const downloadUrl = await getDownloadURL(imageRef);
    logger.info(`Image uploaded successfully: ${imagePath}`);
    return downloadUrl;
  } catch (error) {
    logger.error(`Failed to upload image to ${imagePath}:`, error);
    throw new Error(`Failed to upload image: ${error.message}`);
  }
}

export function buildContentImagePath(groupId, contentId) {
  return `${groupId}/content/images/${contentId}`;
}

export function buildUserProfileImagePath(userId) {
  return `users/${userId}/profile.jpg`;
}

export function buildGroupLogoPath(groupId) {
  return `groups/${groupId}/logo.png`;
}
